import { DEFAULT_LANGUAGE, LANGUAGE_COOKIE } from '@/config/lang'
import type { Language } from '@/config/lang'
import { getCookie, setCookie } from '@/utils/cookie'

/** Наш ли это язык — приложение знает три. */
function toLanguage(value: string): Language | null {
  return value === 'uz' || value === 'en' || value === 'ru' ? value : null
}

/**
 * Текущая локаль. Пока клиент не выбрал язык сам, говорим с ним на узбекском:
 * cookie появляется только после подтверждения на экране выбора, поэтому её
 * отсутствие и означает «не выбирал».
 *
 * Язык клиента Telegram здесь намеренно не смотрим: у половины аудитории
 * мессенджер стоит на русском, и первый экран открывался бы не на том языке,
 * который ждёт бренд. Выбор клиента всё так же сильнее — он живёт в cookie.
 *
 * Эту же локаль http-клиент кладёт в заголовок `X-Language`, а прокси
 * переводит в параметр `Language` — значит и названия блюд с бэкенда придут
 * на том же языке, что интерфейс, без отдельной синхронизации.
 */
export function getLanguage(): Language {
  return toLanguage(getCookie(LANGUAGE_COOKIE)) ?? DEFAULT_LANGUAGE
}

/** Пустое значение стирает cookie — язык снова «не выбран». */
export function setLanguage(value: Language | ''): void {
  setCookie(LANGUAGE_COOKIE, value)
}
